import { attr } from '@square/dashboard-data/utils/ember-model-stubs';
import BaseAddonsSettings from './base-addons-settings';
export default BaseAddonsSettings.extend({
  isEmployeeTrackingEnabled: attr(Boolean, {
    defaultValue: true
  })
});